const ipFormInput = document.getElementById('ipFormInput');
//const ipFormInput_pop = document.getElementById('ipFormInput-pop');
    
fetch('https://api.ipify.org?format=json')
    .then((response) => { return response.json() })
    .then((json) => {
        const ip = json.ip;
        ipFormInput.value = ip;
        //ipFormInput_pop.value = ip;
    })
    .catch((err) => { console.error(`Error getting IP Address: ${err}`) })

$('#subscribeForm').submit(function (event) {
    event.preventDefault();
    $('#alert').text('Processing...').fadeIn(0);
    $.ajax({
        url: 'https://cloud.email.weruva.com/sign-up-web',
        type: 'post',
        data: $('#subscribeForm').serialize(),
        dataType: 'json',
        success: function (json) {
            console.log(json.message);
            if (json.ok) {
                subscribeForm.style.display = "none";
                success.style.display = "block";
            } else {
                console.log(json.ok);
                console.log(json.message);
                alert(json.message);
            }
        },
        error: function (data) {
            console.log('An error occurred.');
            console.log(data);
        }
    });
});

$('#subscribeFormPop').submit(function (event) {
    event.preventDefault();
    const popupClose = document.querySelector('.newsletter__popup-container-close');
    $('#alert').text('Processing...').fadeIn(0);
    $.ajax({
        url: 'https://cloud.email.weruva.com/sign-up-web',
        type: 'post',
        data: $('#subscribeFormPop').serialize(),
        dataType: 'json',
        success: function (json) {
            console.log(json.message);
            if (json.ok) {
                subscribeFormPop.style.display = "none";
                successPop.style.display = "block";
                setTimeout(function () {
                    popupClose.click();
                }, 4500);
            } else {
                console.log(json.ok);
                console.log(json.message);
                alert(json.message);
            }
        },
        error: function (data) {
            console.log('An error occurred.');
            console.log(data);
        }
    });
});